import { ReactElement } from 'react';
import * as React from 'react';

import styles from './boost-adress-reminder.module.scss';
import { useCountry } from '@utmb/contexts/CountryContext';
import SimpleDashboardMemberView from '@utmb/types/view/SimpleDashboardMemberView';
import { useUser } from '@utmb/contexts/AuthContext';
import { UserAccountTypeEnum } from '@utmb/types/enum/UserAccountTypeEnum';
import { useRouter } from 'next/router';
import { fetchTheAPI, TENANCY_DEFAULT } from '@utmb/utils/utmb';
import { Font } from '@utmb/design-system/text/font';

export const BoostAdressReminder = (): ReactElement | null => {
    const { isAuthenticated, me, getToken, isLoginInProgress } = useUser();
    const [isLoginMemberInProgress, setIsLoginMemberInProgress] = React.useState(false);
    const [memberSimple, setMemberSimple] = React.useState<SimpleDashboardMemberView | null>(null);
    const { countries, initCountries } = useCountry();
    const { locale } = useRouter();

    React.useEffect(() => {
        initCountries();
    }, []);

    const initializeDashboardSimple = React.useCallback(async (): Promise<void> => {
        if (isLoginMemberInProgress || memberSimple || isLoginInProgress) return;

        setIsLoginMemberInProgress(true);
        try {
            if (isAuthenticated && me?.email && me?.accountType === UserAccountTypeEnum.MEMBER) {
                const token = await getToken();
                const params: { lang: string; raceYearId?: string } = { lang: locale! };

                const member = (await fetchTheAPI({
                    isClient: true,
                    path: `/users/dashboard/member/simple`,
                    params,
                    bearer: token,
                    tenantId: TENANCY_DEFAULT,
                })) as SimpleDashboardMemberView;
                setMemberSimple(member);
            }
        } finally {
            setIsLoginMemberInProgress(false);
        }
    }, [isLoginInProgress, isAuthenticated, me, getToken, setMemberSimple, setIsLoginMemberInProgress]);
    React.useEffect(() => {
        initializeDashboardSimple().then();
    }, [initializeDashboardSimple]);

    return memberSimple ? (
        <div className={styles.boostAdressReminder}>
            <Font.FuturaBold>{memberSimple.information.address}</Font.FuturaBold>
            <Font.FuturaBold>{`${memberSimple.information.zipcode} ${memberSimple.information.city}`}</Font.FuturaBold>
            <Font.FuturaBold>{`${countries.find((target) => target.code === memberSimple.information.countryCode)?.name}`}</Font.FuturaBold>
        </div>
    ) : null;
};
